module.exports = __webpack_public_path__ + "static/media/frf_list.ee406876.svg";